/* System defined core library */
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BootstrapParams } from '../../../../../bootstrap-params';

/* User defined library/components */
import { ExamFeatureService } from '../../../../shared/services/exam-feature.service';
import { UtilityService } from '../../../../shared/services/utility.service';
import { SelectedExamDetailService } from '../../../shared/services/selected-exam-detail.service';

/* User defined models */
import { AppointmentDetail } from '../../../../shared/models/scheduling/appointmentdetail.model';
import { AppointmentSearch } from '../../../../shared/models/scheduling/appointmentSearch.model';
import { BatteryConfig } from '../../../../shared/models/scheduling/batteryConfig.model';
import { Candidate } from '../../../../shared/models/scheduling/candidate.model';
import { Client } from '../../../../shared/models/scheduling/client.model';
import { Program } from '../../../../shared/models/scheduling/program.model';
import { TestingAccommodation } from '../../../../shared/models/scheduling/testingAccommodation.model';
import { Timezone } from '../../../../shared/models/scheduling/timezone.model';

/* User defined enums/constants */
import { ComponentType } from '../../../../shared/enums/scheduling.enum';


@Component({
  selector: 'app-appointment-info',
  templateUrl: './appointment-info.component.html',
  styleUrls: ['./appointment-info.component.scss'],
})
export class AppointmentInfoComponent implements OnDestroy, OnChanges {

  /* User defined private/public variables  */
  public appointmentSearch: AppointmentSearch;
  public appointmentCount: any;
  public showVerificationDetailView: boolean = false;
  public client: Client;
  public isProctor: boolean;
  public program: Program;
  public testingAccommodation: TestingAccommodation[];
  public programLogo: any;
  public eligibility: any;
  public eligibilityDetails: any;
  public candidate: Candidate;
  public timezone: Timezone;
  public batteryConfig: BatteryConfig;
  public totalDuration: number = 0;

  /* Input-OutPut parameters decalartions */
  @Input() public appointmentDetails: AppointmentDetail[] = [];

  /* Service subscriptions */
  appointmentSearch$: Subscription;
  appointmentCount$: Subscription;

  appointmentDetailData$: Subscription;
  client$: Subscription;
  program$: Subscription;
  testingAccommodation$: Subscription;
  programLogo$: Subscription;
  translateLanguage$: Subscription;
  eligibility$: Subscription;
  eligibilityDetails$: Subscription;
  candidate$: Subscription;
  timezone$: Subscription;
  batteryConfig$: Subscription;

  /* Constructor declaration with required injected services */
  constructor(
    private bootStrapParams: BootstrapParams,
    private selectedExamDetailService: SelectedExamDetailService,
    private translate: TranslateService,
    private utilityService: UtilityService
  ) {

    this.client$ = selectedExamDetailService.client.subscribe(
      client => {
        this.client = client;
      });

    this.program$ = selectedExamDetailService.program.subscribe(
      program => {
        this.program = program;
      });

    this.programLogo$ = selectedExamDetailService.programLogo.subscribe(
      programLogo => {
        this.programLogo = programLogo;
      });

    this.appointmentSearch$ = selectedExamDetailService.appointmentSearch.subscribe(
      appointmentSearch => {
        this.appointmentSearch = appointmentSearch;
      });

    this.batteryConfig$ = selectedExamDetailService.batteryConfig.subscribe(
      batteryConfig => {
        this.batteryConfig = batteryConfig;
      });

    this.appointmentDetailData$ = selectedExamDetailService.selectedAppointmentDetails.subscribe(
      appointDetailData => {
        this.appointmentDetails = appointDetailData;
        if (appointDetailData) this.totalDuration = ExamFeatureService.calculateTotalDuration(this.appointmentDetails);
      });

    this.testingAccommodation$ = selectedExamDetailService.applicableTestingAccommodations.subscribe(
      applicableTestingAccommodations => {
        this.testingAccommodation = applicableTestingAccommodations;
      });

    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      });

    this.eligibility$ = selectedExamDetailService.eligibility.subscribe(
      eligibility => {
        this.eligibility = eligibility;
      });

    this.eligibilityDetails$ = selectedExamDetailService.eligibilityDetails.subscribe(
      eligibilityDetails => {
        this.eligibilityDetails = eligibilityDetails;
      });

    this.candidate$ = selectedExamDetailService.candidate.subscribe(
      candidate => {
        this.candidate = candidate;
      });

    this.timezone$ = selectedExamDetailService.timezone.subscribe(
      timezone => {
        this.timezone = timezone;
      });
  }

  /**
   * check if image exists with the input source url
   * using height and return true
   * @param imageUrl
   */
  checkIfImageExists(imageUrl: any) {
    const image = new Image();
    image.src = imageUrl;
    $(image).on('load', () => {

    });
    this.programLogo = image;
    this.selectedExamDetailService.setProgramLogo(this.programLogo);
    return !!image.height;
  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit() {
    sessionStorage.setItem('previousUrl', window.location.pathname);
    if (!this.utilityService.isDataValidToLoadComponent(ComponentType.AppointmentInfoComponent)) return;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.appointmentDetails && changes.appointmentDetails.currentValue) {
      const currentChanges = changes.appointmentDetails.currentValue;
      if (currentChanges && currentChanges[0] && currentChanges[0].exam && currentChanges[0].program) {
        this.checkIfImageExists('../../../../../../Assets/images/programs/' + currentChanges[0].program.code + '.gif');
      }
    }

    this.isProctor = this.selectedExamDetailService.isProctored;
  }

  /* Reset the shared service if component is unloaded */
  ngOnDestroy(): void {
    this.selectedExamDetailService.setAppointmentSearch(null);
    //this.selectedExamDetailService.SetCandidateDataSource(null);
    this.selectedExamDetailService.SetSlotDataSource(null);
    this.selectedExamDetailService.SetAppointmentDetail(null);
    this.selectedExamDetailService.isSearchPerformed = false;
    this.selectedExamDetailService.setProgramLogo(null);
  }

  durationToStr(val: number) {
    return this.utilityService.durationToStr(val);
  }

  getClass() {
    return this.client ? this.client.code.toLowerCase() : '';
  }

  getCandidateName() {
    let name = '';
    name += this.candidate ? this.candidate['FirstName'] + ' ' : '';
    name += this.candidate ? this.candidate['LastName'] : '';
    return name;
  }
}
